module.exports = __webpack_public_path__ + "static/img/bg3.5dbef53a.png";